import React, { useEffect } from 'react'
import { DisabledMemberContainer, DisabledMemberContent, DisabledMemberDescription, DisabledMemberTitle } from './Theme'

const DisabledMember = () => {

  useEffect(() => {
    const timer = setTimeout(() => {
      const orgWebsite = localStorage.getItem("shul_website") || "";
      window.location.href = orgWebsite
    }
    , 10000)
    return () => clearTimeout(timer)
  }
  , [])

  return (
    <DisabledMemberContainer className="page-content">
        <DisabledMemberContent>
          <DisabledMemberTitle>Member Portal Disabled</DisabledMemberTitle>
          <DisabledMemberDescription>
            The member’s portal is currently disabled. Please reach out to your organization’s administrator for assistance.
          </DisabledMemberDescription>
        </DisabledMemberContent>
    </DisabledMemberContainer>
  )
}

export default DisabledMember